export default __webpack_public_path__ + "static/media/allCourseTwitter-600x314.bd4ad24e.jpg";